/**
 * Utility functions for extracting pharmacy data from API responses
 */

/**
 * Extracts pharmacy data from API response and formats it for updatePharmacyFromWebSocket
 */
export const extractPharmacyFromResponse = (response: any): any | null => {
  if (!response?.data?.pharmacy) {
    return null;
  }

  // pharmacy structure: { pharmacyId: "...", detail: "..." }
  // Add status_code: 200 to match expected format
  return {
    status_code: 200,
    ...response.data.pharmacy
  };
};

/**
 * Extracts pharmacy data from WebSocket message
 */
export const extractPharmacyFromMessage = (message: any): any | null => {
  if (!message?.data?.pharmacy) {
    return null;
  }

  return {
    status_code: 200,
    ...message.data.pharmacy
  };
};

